import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { InfoboxComponent } from '@recruitee/components/infobox';
import { TranslatePipe } from '@recruitee/i18n';
import type { ScorecardsResult } from '@recruitee/interview-results-types';

import { InterviewResultSummaryScorecardsItemComponent } from './interview-result-summary-scorecards-item/interview-result-summary-scorecards-item.component';

@Component({
  selector: 'rt-interview-result-summary-scorecards',
  templateUrl: 'interview-result-summary-scorecards.component.html',
  styleUrls: ['./interview-result-summary-scorecards.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [InterviewResultSummaryScorecardsItemComponent, TranslatePipe, InfoboxComponent],
})
export class InterviewResultSummaryScorecardsComponent {
  @Input() public scorecardsResults: ScorecardsResult[];
  @Input() public hasHiddenResults: boolean = false;

  public trackByScorecard(index: number, scorecard: ScorecardsResult): string {
    return JSON.stringify(scorecard);
  }
}
